import { defineMessages } from "react-intl";

const UPDATE_USER_FORM_FIELDS = "update-user-form-fields";

const updateUserFormFieldsMessages = defineMessages({
  changePassword: {
    id: `${UPDATE_USER_FORM_FIELDS}.change-password`,
    defaultMessage: "Change password?"
  }
});

export default updateUserFormFieldsMessages;
